import React, { useState, useEffect } from 'react';

import './BubbleAlert.scss';
import { BubbleButton } from '.';

interface BubbleAlertPropsBase {
  variant?: 'crimson' | 'banana' | 'lime' | 'dirt' | 'ocean' | 'emerald';
  dismissible?: boolean | string;
  onDismiss?: () => void;
  containerClassName?: string;
}

export type BubbleAlertProps = React.HTMLAttributes<HTMLDivElement> & BubbleAlertPropsBase;

export default function BubbleAlert(props: BubbleAlertProps) {
  const [dismissed, setDismissed] = useState(false);
  const {
    // from component
    variant,
    dismissible,
    onDismiss,
    containerClassName: propContainerClasses,
    // from div
    className: propClasses,
    children,
    ...rest
  } = props;

  const classes = ['bubble-alert'];
  if (variant) classes.push(variant);
  if (propClasses) classes.push(propClasses);

  const containerClasses = ['bubble-alert-container'];
  if (dismissible && dismissed) containerClasses.push('hide');
  if (propContainerClasses) containerClasses.push(propContainerClasses);

  useEffect(() => {
    setDismissed(false);
  }, [dismissible]);

  return (
    <div className={containerClasses.join(' ')}>
      <div {...rest} className={classes.join(' ')}>
        <div className="alert-content">{children}</div>
        {dismissible && (
          <BubbleButton
            inverse
            variant="white"
            className="close-btn p-0-i"
            onClick={() => {
              setDismissed(true);
              if (onDismiss) onDismiss();
            }}
            icon="xmark"
          />
        )}
      </div>
    </div>
  );
}
